let optionalUiStylesPromise: Promise<unknown> | null = null;

export const loadOptionalUiStyles = (): Promise<unknown> => {
  if (optionalUiStylesPromise !== null) {
    return optionalUiStylesPromise;
  }

  optionalUiStylesPromise = import('./optional.scss');

  return optionalUiStylesPromise;
};
